// extracted by mini-css-extract-plugin
export default {"totals_row":"TotalsTable_totals_row__yBCQT","disabled_cell":"TotalsTable_disabled_cell__3MC8q","disabled_header":"TotalsTable_disabled_header__jKBsn"};